module.exports = __webpack_public_path__ + "img/about-banner.14c092ba.png";